<template>
  <div>
    <b-button @click="closeLot" style="display: flex; flex-direction: row; align-items: center;">
      <i class='p-0 fa fa-pencil-square-o' style="margin-right: 8px;"></i>
      Cerrar
    </b-button>
  </div>
</template>

<script>
import EventBus from '../../../../Modules/EventBus';

export default {
  name: 'ActionsCierreLotes',
  props: ['data', 'index'],
  mounted: function () {
  },
  methods: {
    closeLot: function () {
      EventBus.$emit('close-lot', this.data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/cierre-lotes-management/cierre-lotes-list/ActionsCierreLotes.vue